import React, { useEffect, useState } from "react";
import dollars from "../../dollar-format";
import {percent} from "../../utils";
import {stringISOtoUS} from "../../date-converter";
import LinkComp from "../LinkComp";
import svgSortAsc from "../../svgs/arrow-up.svg";
import svgSortDesc from "../../svgs/arrow-down.svg";
import Icon from "../Icon";
const cloneDeep = require('lodash.clonedeep');

export default ({columns, rows, hasTotalRow, className, linkInNewTab, hideSort}) => {
    const [sortOrder, setSortOrder] = useState({sortKey:'', order:'default'})
    const [updatedRows, setUpdatedRows] = useState(rows);
    const [keys, setKeys] = useState([]);
    useEffect(() => {
        let _keys = Array.isArray(rows) ? { ...rows } : rows;
        let keys = Object.keys(_keys);

        if (keys.includes('Total')) {
            let filteredKey = keys.filter(item => item !== "Total");
            filteredKey.sort();
            filteredKey.push('Total')
            keys = filteredKey;
        }
        setKeys(keys);
    }, [])
   
    const formatTableValue = ({value, key, type, withCents, columnKey, isLastRow}) => {
        if (value === null || value === '') return;
        switch (type) {
            case '$':
                return value < 0 ? `(${dollars(Math.abs(value), withCents)})` : dollars(value, withCents);
            case '%':
                return percent(value);
            case 'date':
                return stringISOtoUS(value);
            case 'key':
                return key;
            default:{
                if(columnKey ==='CLOSE_OF_ESCROW' && !isLastRow){
                    return stringISOtoUS(value)
                }
                return value;
            }
        }
    };

    const sortBy = (column, key)=> {
        const defaultRows = cloneDeep(rows);
        let clonedRows = cloneDeep(updatedRows); 
        const { sortKey, order } = sortOrder;
        let colOrder = order
        colOrder = colOrder == 'default' ? 'asc' : colOrder == 'asc' ? 'dsc' : colOrder == 'dsc' ? 'default' : 'default';
        const totalRow = clonedRows.splice(clonedRows.length-1)
        let _rows = [];
        setSortOrder( {
            sortKey: column.key,
            order: colOrder
        })
        if (colOrder === 'asc') {
            _rows = clonedRows.sort((a, b) => {
                const _a = a[key] ? a[key] : a[key] == 0 ? 0 : "" || "";
                const _b = b[key] ? b[key] : b[key] == 0 ? 0 : "" || "";
                const dateA = new Date(_a);
                const dateB = new Date(_b);
                const isDateA = !isNaN(dateA.getTime());
                const isDateB = !isNaN(dateB.getTime());
                if (isDateA && isDateB) {
                    return dateA - dateB;
                }
                if (typeof _a == 'string' && typeof _b == 'string') {
                    if (!isNaN(_a) && !isNaN(parseFloat(_a)) && !isNaN(_b) && !isNaN(parseFloat(_b))) {
                        return Number(_a) < Number(_b) ? -1 : 1; 
                    } else {
                        return _a.localeCompare(_b); 
                    }
                } else {
                    return _a < _b ? -1 : 1; 
                }
              })
        }
        else if (colOrder === 'dsc'){
            _rows = clonedRows.sort((a, b) => {
                const _a = a[key] ? a[key] : a[key] == 0 ? 0 : "" || "";
                const _b = b[key] ? b[key] : b[key] == 0 ? 0 : "" || "";
                const dateA = new Date(_a);
                const dateB = new Date(_b);
                const isDateA = !isNaN(dateA.getTime());
                const isDateB = !isNaN(dateB.getTime());
                if (isDateA && isDateB) {
                    return dateB - dateA;
                }
                if (typeof _a == 'string' && typeof _b == 'string') {
                    if (!isNaN(_a) && !isNaN(parseFloat(_a)) && !isNaN(_b) && !isNaN(parseFloat(_b))) {
                        return Number(_a) > Number(_b) ? -1 : 1; 
                    } else {
                        return _b.localeCompare(_a); 
                    }
                } else {
                    return _a > _b ? -1 : 1; 
                }
              })
        } else {
            _rows = [...defaultRows.splice(0, defaultRows.length - 1)];
        }
        _rows.push(totalRow[0]);
        setUpdatedRows(_rows);        
    }

    const getLink = ({hasLink, id, year}) => {
        switch (hasLink) {
            case 'property':
                return `${arc.path.base}property/${id}`;
            case 'agent-pipeline':
                return `${arc.path.base}agent-pipeline/${id}`;
            case 'agent-commission-procured':
                return `${arc.path.base}agent-commission-breakdown/${year}/${id}/procured`;
            case 'agent-commission-paid':
                return `${arc.path.base}agent-commission-breakdown/${year}/${id}/paid`;
        }
        return '';
    }

    if (!keys.length)
        return <div className='PipelineTable_no_results'>No results found</div>;

    return (
        <div className = {`Scroll-container ${className}`}>
        <table className={`PipelineTable ${className ? className : ''}`}>
            <thead id="table-header" >
            <tr>
                {
                    columns.map((column, index) =>{
                     const { sortKey, order } = sortOrder;
                     return  <th key={index} className="Buckets_th border_top">
                    {column.name =="Status" ?                     
                        <div class="SortTable_th_name active">
                            <button className="btn-text" onClick={()=>sortBy(column, 'STATUS')}> 
                                <div className={`SortTable_th_name ${ sortKey == column.key && (order === "asc" || order === "dsc") ? "active" : ""}`}>
                                        <span
                                            className={`SortTable_th_name_icon top ${sortKey == column.key && order === "asc" ? "active" : ""}`}>
                                            <Icon svg={svgSortAsc}/>
                                        </span>
                                        {column.name}
                                    <span
                                        className={`SortTable_th_name_icon bottom ${sortKey == column.key && order === "dsc" ? "active" : ""}`}>
                                            <Icon svg={svgSortDesc}/>
                                        </span>
                                </div>                                
                            </button>
                        </div> : column.name == 'Property Name' ? <div class="SortTable_th_name active">
                            <button className="btn-text" onClick={()=>sortBy(column, 'NAME')}> 
                                <div className={`SortTable_th_name ${ sortKey == column.key && (order === "asc" || order === "dsc") ? "active" : ""}`}>
                                        <span
                                            className={`SortTable_th_name_icon top ${sortKey == column.key && order === "asc" ? "active" : ""}`}>
                                            <Icon svg={svgSortAsc}/>
                                        </span>
                                        {column.name}
                                    <span
                                        className={`SortTable_th_name_icon bottom ${sortKey == column.key && order === "dsc" ? "active" : ""}`}>
                                            <Icon svg={svgSortDesc}/>
                                        </span>
                                </div>                                
                            </button>
                        </div> : column.name == 'Listing Date' ? <div class="SortTable_th_name active">
                        <button className="btn-text" onClick={()=>sortBy(column, 'LISTED_DATE')}> 
                            <div className={`SortTable_th_name ${ sortKey == column.key && (order === "asc" || order === "dsc") ? "active" : ""}`}>
                                    <span
                                        className={`SortTable_th_name_icon top ${sortKey == column.key && order === "asc" ? "active" : ""}`}>
                                        <Icon svg={svgSortAsc}/>
                                    </span>
                                    {column.name}
                                <span
                                    className={`SortTable_th_name_icon bottom ${sortKey == column.key && order === "dsc" ? "active" : ""}`}>
                                        <Icon svg={svgSortDesc}/>
                                    </span>
                            </div>                                
                        </button>
                    </div> :<div> <button className="btn-text" onClick={()=>sortBy(column, column.key)}> 
                            <div className={`SortTable_th_name ${ sortKey == column.key && (order === "asc" || order === "dsc") ? "active" : ""}`}>
                                    {!hideSort && <span
                                        className={`SortTable_th_name_icon top ${sortKey == column.key && order === "asc" ? "active" : ""}`}>
                                        <Icon svg={svgSortAsc}/>
                                    </span>}
                                    {column.name}
                                {!hideSort && <span
                                    className={`SortTable_th_name_icon bottom ${sortKey == column.key && order === "dsc" ? "active" : ""}`}>
                                        <Icon svg={svgSortDesc}/>
                                    </span>}
                            </div>                                
                        </button>
                    </div> }
                    </th>}
                    )
                }
            </tr>
            </thead>
            <tbody>
            {
                keys.map((key, index) => (
                    <tr key={key}>
                        {
                            columns.map((column, colIndex) => {
                                if (column.hasLink && updatedRows[key].id)
                                    return (
                                        <td key={key + '-' + colIndex}
                                            className={`${column.class ? column.class : 'PipelineTable_td'} ${hasTotalRow && index === keys.length - 2 ? 'border-bottom' : ''}`}>
                                          <LinkComp
                                          target={
                                            !!linkInNewTab ? "_blank" : ""
                                          }
                                          to={{
                                            pathname: getLink({
                                              hasLink: column.hasLink,
                                              id: updatedRows[key].id,
                                              year: column.year,
                                            }),
                                            state: {
                                              fromListUrl:
                                                window.location.pathname +
                                                window.location.search,
                                            },
                                          }}
                                        >
                                                {
                                                    formatTableValue({
                                                        value: updatedRows[key][column.key],
                                                        key,
                                                        type: column.format,
                                                        withCents: column.withCents,
                                                        columnKey:column.key,
                                                       
                                                    })
                                                }
                                            </LinkComp>
                                        </td>
                                    );
                                return (
                                    <td key={key + '-' + colIndex}
                                        className={`PipelineTable_td${updatedRows[key][column.key] < 0 ? ' red' : ''}${hasTotalRow && index === keys.length - 2 ? ' border-bottom' : ''} ${column.class ? column.class : ''}`}>
                                        {                                                                                           
                                            formatTableValue({
                                                value: updatedRows[key][column.key],
                                                key,
                                                type: column.format,
                                                withCents: column.withCents,
                                                columnKey:column.key,
                                                isLastRow:index === keys.length-1
                                            })
                                        }
                                    </td>
                                );
                            })
                        }
                    </tr>
                ))
            }
            </tbody>
        </table>
        </div>
       
    );
}